// Use this controller when you have a datalist which has a label AND a value that is different
// datalists are great when using with text inputs, but you don't always want the label and value to be the same
// This adds support for showing one value in the UI, but a different value being set
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output", "outputContainer", "outputDisplay"]
  static values = {
    prefix: String
  }

  connect() {
    $(this.element).on("select2:select", (e) => this.selected(e) )
  }

  selected(ev) {
    this.setOutput(ev.target.value)
  }

  setOutput(value) {
    if (this.hasPrefixValue) {
      value = `${this.prefixValue}${value}`
    }

    this.outputTarget.value = value
    this.outputDisplayTarget.textContent = value
    this.outputContainerTarget.classList.toggle("hidden", !value)
  }
}
